import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-imagesloaded';
import 'flickity/dist/flickity.css';

const carousels = [];

export default function init() {
  const sliders = [...document.querySelectorAll('.js-carousel')];
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    let carousel;
    if (slider.dataset.navfor) {
      carousel = new Flickity(slider, {
        contain: true,
        pageDots: false,
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        asNavFor: `#${slider.dataset.navfor}`,
        groupCells: slider.dataset.group,
      });
    } else {
      carousel = new Flickity(slider, {
        contain: true,
        pageDots: slider.hasAttribute('data-dots'),
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: slider.hasAttribute('data-buttons'),
        draggable: false,
        arrowShape:
          'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z',
      });
    }

    const buttonGroup = slider.parentElement.querySelector('.js-gallery-controls');

    if (buttonGroup) {
      const previousBtn = buttonGroup.querySelector('.js-carousel-prev');
      const nextBtn = buttonGroup.querySelector('.js-carousel-next');
      // set custom controls
      previousBtn.addEventListener('click', () => {
        carousel.previous();
      });
      nextBtn.addEventListener('click', () => {
        carousel.next();
      });
      carousel.on('change', () => {
        // set disabled states
        const slideNumber = carousel.selectedIndex;
        previousBtn.disabled = !slideNumber;
        nextBtn.disabled = slideNumber + 1 === carousel.slides.length;
      });
    }

    carousel.on('lazyLoad', (event, cellElement) => {
      let img;
      if (cellElement.tagName.toLowerCase() === 'button') {
        img = cellElement.querySelector('.flickity-lazyloaded');
      } else {
        img = cellElement;
      }
      if (img.hasAttribute('data-sizes')) {
        img.setAttribute('sizes', img.dataset.sizes);
        img.removeAttribute('data-sizes');
      }
    });
    carousels.push(carousel);
  });
}
